var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"w-feed",attrs:{"size":"mini","type":"primary","disabled":true},on:{"click":_vm.doFeed}},[(!_vm.subscribed)?_c('i',{staticClass:"el-icon-bell"}):_c('i',{staticClass:"el-icon-message-solid"}),(!_vm.subscribed)?_c('span',[_vm._v("订阅")]):_c('span',[_vm._v("取消订阅")])])
}
var staticRenderFns = []

export { render, staticRenderFns }